import { Image } from '@fluentui/react-components';
import { Link } from '@tanstack/react-router';
import { IdentityMenu } from '../Core/IdentityMenu';
import LanguageSelector from '../Core/LanguageSelector';

export function AppHeader() {
  return (
    <header id="header">
      <Link to="/folder">
        <Image alt="Logo" src="/logo/SmartPermissions.png" width={200} />
      </Link>
      {import.meta.env.MODE === 'staging' && <h3 style={{ color: 'purple ' }}>🧪 {import.meta.env.MODE} 🚀</h3>}
      {import.meta.env.MODE === 'development' && <h3 style={{ color: 'orange ' }}>🛠️ {import.meta.env.MODE} 🚧</h3>}
      <div
        style={{
          textAlign: 'right',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <LanguageSelector />
        <IdentityMenu />
      </div>
    </header>
  );
}
